// extracted by mini-css-extract-plugin
module.exports = {"app-content":"app-content_app-content__2yrEe","loading":"app-content_loading__2i18s"};